import type { OAISchema } from '~/types/openapi';
import { openModal } from '~/utils/mobileApp';

type Props = {
  categories: OAISchema['PlacementEventResponse']['categories'];
};

export function EventCategoryList({ categories }: Props) {
  if (!categories?.length) return null;

  return (
    <section className="grid grid-cols-5 gap-x-8 gap-y-16 px-20 py-16">
      {categories?.map((category) => {
        return (
          <button
            className="flex items-start"
            key={category.landingUrl}
            type="button"
            onClick={() => {
              if (!category.landingUrl) return;
              openModal({ url: category.landingUrl });
            }}
          >
            <img src={category.imageUrl} alt="카테고리" />
          </button>
        );
      })}
    </section>
  );
}
